// Global page scroll animations (these seem to be more performant and reliable using jquery)
import { $ } from "../index";

var page = $("html, body");

page.on(
  "scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove",
  function () {
    page.stop();
  },
);

// Handle links starting with '#' only
$("a[href^='#']").on("click", function (e) {
  var id = $(this).attr("href");
  var $id = $(id);

  if ($id.length === 0) {
    return;
  }

  // Prevent standard hash navigation (avoid blinking in IE)
  e.preventDefault();

  var toTop = id === "#top";
  var offset = toTop ? 0 : $("header").outerHeight() * 0.6 - 1;
  var pos = $id.offset().top - offset;

  page.animate({ scrollTop: pos }, 1200, "easeInOutQuint");
});

// Extend jQuery easings
$.extend($.easing, {
  easeInOutQuint: function (x, t, b, c, d) {
    if ((t /= d / 2) < 1) return (c / 2) * t * t * t * t * t + b;
    return (c / 2) * ((t -= 2) * t * t * t * t + 2) + b;
  },
});
